// Database işlemeleri yapılacak ve dönen datanın state e geçmesi için mutation a gönderilecek
import sendReq from '@/utils/request'

export const country_list = async ({ commit }, data) => {
   commit('definationLoading', true);
    let res;
    res = await sendReq("get","countries")
    commit('listCountries', res.data);
   commit('definationLoading', false);
}

export const city_list = async ({ commit }, data) => {
   commit('definationLoading', true);
    let res;
    console.log(Array.isArray(data), data)
    if(Array.isArray(data))
      res = await sendReq("get","countries/"+data[0]+"/cities")
    else
      res = await sendReq("get","countries/"+data.parent_id+"/cities")
    commit('listCities', res.data);
   commit('definationLoading', false);
}

export const district_list = async ({ commit }, data) => {
   commit('definationLoading', true);
    let res;
    if(Array.isArray(data))
      res = await sendReq("get","countries/"+data[0]+"/cities/"+data[1]+"/towns", data)
    else
       res = await sendReq("get","countries/"+data.country+"/cities/"+data.city+"/towns", data)
    commit('listTowns', res.data);
   commit('definationLoading', false);
}

export const addCountry = async ({ commit }, data) => {
    let res;
    res = await sendReq("post","countries", data)
    commit('status', res.data);
}

export const deleteCountry = async ({ commit }, data) => {
    let res;
    res = await sendReq("delete","countries/"+data.country_id, data)
    commit('status', res.data);
}

 export const editCountry = async ({ commit }, data) => {
    let res;
    res = await sendReq("put","countries/"+data.country_id, data)
    commit('status', res.data);
 }

 export const addCity = async ({ commit }, data) => {
    let res;
    res = await sendReq("post","countries/"+data.country_id+"/cities", data)
    commit('status', res.data);
 }

 export const editCity = async ({ commit }, data) => {
    let res;
    res = await sendReq("put","countries/"+data.country_id+"/cities/"+data.city_id, data)
    commit('status', res.data);
 }

 export const deleteCity = async ({ commit }, data) => {
    let res;
    res = await sendReq("delete","countries/"+data.country_id+"/cities/"+data.city_id, data)
    commit('status', res.data);
 }

 export const addTown = async ({ commit }, data) => {
    let res;
    res = await sendReq("post","countries/"+data.country_id+"/cities/"+data.city_id+"/towns", data)
    commit('status', res.data);
 }

 export const editTown = async ({ commit }, data) => {
    let res;
    res = await sendReq("put","countries/"+data.country_id+"/cities/"+data.city_id+"/towns/"+data.town_id, data)
    commit('status', res.data);
 }

 export const deleteTown = async ({ commit }, data) => {
    let res;
    res = await sendReq("delete","countries/"+data.country_id+"/cities/"+data.city_id+"/towns/"+data.town_id, data)
    commit('status', res.data);
 }

 export const subscription_list = async ({ commit }, data) => {
    commit('definationLoading', true);
    let res;
    res = await sendReq("get","subscriptions")
    commit('listSubscription', res.data);
    commit('definationLoading', false);
}

export const addSubscription = async ({ commit }, data) => {
    let res;
    res = await sendReq("post","subscriptions", data)
    commit('listSubscription', res.data);
 }

 export const editSubscription = async ({ commit }, data) => {
    let res;
    res = await sendReq("put","subscriptions/"+data.id, data)
    commit('status', res.data);
 }

 export const deleteSubscription = async ({ commit }, data) => {
    let res;
    res = await sendReq("delete","subscriptions/"+data.id, data)
    commit('status', res.data);
 }

 export const accounttype_list = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","accounttypes", data)
   commit('listAccountType', res.data);
   commit('definationLoading', false);
}

export const addAccountType = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","accounttypes", data)
   commit('status', res.data);
}

export const editAccountType = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","accounttypes/"+data.id, data)
   commit('status', res.data);
}

export const deleteAccountType = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","accounttypes/"+data.id, data)
   commit('status', res.data);
}

export const job_list = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","jobs", data)
   commit('listJobs', res.data);
   commit('definationLoading', false);
}

export const addJobs = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","jobs", data)
   commit('status', res.data);
}

export const editJobs = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","jobs/"+data.id, data)
   commit('status', res.data);
}

export const deleteJobs = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","jobs/"+data.id, data)
   commit('status', res.data);
}

export const zonetype_list = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","zonetypes", data)
   commit('listZoneTypes', res.data);
   commit('definationLoading', false);
}

export const addZoneTypes = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","zonetypes", data)
   commit('status', res.data);
}

export const editZoneTypes = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","zonetypes/"+data.id, data)
   commit('status', res.data);
}

export const deleteZoneTypes = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","zonetypes/"+data.id, data)
   commit('status', res.data);
}

export const brand_list = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","panelbrands")
   commit('listBrands', res.data);
   commit('definationLoading', false);
}

export const model_list = async ({ commit }, data) => {
   console.log(data)
   commit('definationLoading', true);
   let res;
   if(Array.isArray(data))
      res = await sendReq("get","panelbrands/"+data[0]+"/models")
   else
      res = await sendReq("get","panelbrands/"+data.parent_id+"/models")
   commit('listModels', res.data);
   commit('definationLoading', false);
}

export const addBrands = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","panelbrands", data)
   commit('status', res.data);
}

export const deleteBrands = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","panelbrands/"+data.id, data)
   commit('status', res.data);
}

export const editBrands = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","panelbrands/"+data.id, data)
   commit('status', res.data);
}

export const addModels = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","panelbrands/"+data.brand_id+"/models", data)
   commit('status', res.data);
}

export const editModels = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","panelbrands/"+data.brand_id+"/models/"+data.id, data)
   commit('status', res.data);
}

export const deleteModels = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","panelbrands/"+data.brand_id+"/models/"+data.id)
   commit('status', res.data);
}

export const signalprotocol_list = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","signalprotocols")
   commit('listProtocols', res.data);
   commit('definationLoading', false);
}

export const addProtocols = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","signalprotocols", data)
   commit('status', res.data);
}

export const editProtocols = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","signalprotocols/"+data.id, data)
   commit('status', res.data);
}

export const deleteProtocols = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","signalprotocols/"+data.id, data)
   commit('status', res.data);
}

export const task_list = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","tasks")
   commit('listTasks', res.data);
   commit('definationLoading', false);
}

export const addTasks = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","tasks", data)
   commit('status', res.data);
}

export const editTasks = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","tasks/"+data.id, data)
   commit('status', res.data);
}

export const deleteTasks = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","tasks/"+data.ID, data)
   commit('status', res.data);
}

export const signal_group_list = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","signalgroups")
   commit('listSignalGroups', res.data);
   commit('definationLoading', false);
}

export const listSignalTypes = async ({ commit }, data) => {
  commit('definationLoading', true);
  let res;
  res = await sendReq("get","signaltypes", data)
  commit('listSignalTypes', res.data);
  commit('definationLoading', false);
}

export const listQuickNotes = async ({ commit }, data) => {
  commit('definationLoading', true);
  let res;
  res = await sendReq("get","quicknotes", data)
  commit('listQuickNotes', res.data);
  commit('definationLoading', false);
}

export const addSignalGroups = async ({ commit }, data) => {
  let res;
  res = await sendReq("post","signalgroups", data)
  commit('status', res.data);
}

export const editSignalGroups = async ({ commit }, data) => {
  let res;
  res = await sendReq("put","signalgroups/"+data.ID, data);
  commit('status', res.data);
}

export const deleteSignalGroups = async ({ commit }, data) => {
  let res;
  res = await sendReq("delete","signalgroups/"+data.ID, data);
  commit('status', res.data);
}

export const addSignalTypes = async ({ commit }, data) => {
  let res;
  res = await sendReq("post","signaltypes", data);
  commit('status', res.data);
}

export const editSignalTypes = async ({ commit }, data) => {
  let res;
  res = await sendReq("put","signaltypes/"+data.ID, data);
  commit('status', res.data);
}

export const deleteSignalTypes = async ({ commit }, data) => {
  let res;
  res = await sendReq("delete","signaltypes/"+data.ID, data);
  commit('status', res.data);
}

export const addQuickNotes = async ({ commit }, data) => {
  let res;
  res = await sendReq("post","quicknotes", data);
  commit('status', res.data);
}

export const deleteQuickNotes = async ({ commit }, data) => {
  let res;
  res = await sendReq("delete","quicknotes/"+data.id, data);
  commit('status', res.data);
}

export const listProducts = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","products", data)
   commit('listProducts', res.data);
   commit('definationLoading', false);
 }

export const addProducts = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","products", data);
   commit('status', res.data);
}

export const editProducts = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","products/"+data.id, data);
   commit('status', res.data);
}

export const deleteProducts = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","products/"+data.id, data);
   commit('status', res.data);
}

export const setProductStatus = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("put","/products/"+data.id+"/active", data)
   commit('setProductStatus', res);
   commit('definationLoading', false);
}

export const listStockMovementTypes = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","stock-movement-types", data)
   commit('listStockMovementTypes', res.data);
   commit('definationLoading', false);
}

export const addStockMovementTypes = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","stock-movement-types", data);
   commit('status', res.data);
}

export const editStockMovementTypes = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","stock-movement-types/"+data.ID, data);
   commit('status', res.data);
}

export const deleteStockMovementTypes = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","stock-movement-types/"+data.ID, data);
   commit('status', res.data);
}

export const listFaultSupportPieces = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","fault-support-pieces", data)
   commit('listFaultSupportPieces', res.data);
   commit('definationLoading', false);
}

export const addFaultSupportPieces = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","fault-support-pieces", data);
   commit('status', res.data);
}

export const editFaultSupportPieces = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","fault-support-pieces/"+data.id, data);
   commit('status', res.data);
}

export const deleteFaultSupportPieces = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","fault-support-pieces/"+data.id, data);
   commit('status', res.data);
}

export const listFaultSupportResults = async ({ commit }, data) => {
   commit('definationLoading', true)
   let res;
   res = await sendReq('get', 'fault-support-result', data)
   commit('listFaultSupportResults', res.data)
   commit('definationLoading', false)
 }

 export const addFaultSupportResult = async ({ commit }, data) => {
   commit('definationLoading', true)
   let res;
   res = await sendReq('post', 'fault-support-result', data)
   commit('status', res.data.status)
   commit('definationLoading', false)
 }

 export const editFaultSupportResult = async ({ commit }, data) => {
   commit('definationLoading', true)
   let res;
   res = await sendReq('put', 'fault-support-result/' + data.id, data)
   commit('status', res.data.status)
   commit('definationLoading', false)
 }

 export const deleteFaultSupportResult = async ({ commit }, data) => {
   commit('definationLoading', true)
   let res;
   res = await sendReq('delete', 'fault-support-result/' + data.id)
   commit('status', res.data.status)
   commit('definationLoading', false)
 }

export const listImportantNumbers = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","emergency-phones", data)
   commit('listImportantNumbers', res.data);
   commit('definationLoading', false);
}

export const addImportantNumbers = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","emergency-phones", data);
   commit('status', res.data);
}

export const editImportantNumbers = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","emergency-phones/"+data.id, data);
   commit('status', res.data);
}

export const deleteImportantNumbers = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","emergency-phones/"+data.id, data);
   commit('status', res.data);
}

export const listVacations = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","vacations", data)
   commit('listVacations', res.data);
   commit('definationLoading', false);
}

export const addVacations = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","vacations", data);
   commit('status', res.data);
}

export const editVacations = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","vacations/"+data.id, data);
   commit('status', res.data);
}

export const deleteVacations = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","vacations/"+data.id, data);
   commit('status', res.data);
}

export const listVacationJobs = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","vacations/"+data.vacationId+"/jobs")
   commit('listVacationJobs', res.data);
   commit('definationLoading', false);
}

export const addVacationJobs = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","vacations/"+data.vacationId+"/jobs", data.jobs);
   commit('status', res.data);
}

export const deleteVacationJobs = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","vacations/"+data.vacationId+"/jobs/"+data.jobId);
   commit('status', res.data);
}

export const listVacation = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","vacations/"+data)
   commit('listVacation', res.data);
   commit('definationLoading', false);
}

export const listEvaluationResults = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","evaluation-results", data)
   commit('listEvaluationResults', res.data);
   commit('definationLoading', false);
}

export const addEvaluationResults = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","evaluation-results", data);
   commit('status', res.data);
}

export const editEvaluationResults = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","evaluation-results/"+data.id, data);
   commit('status', res.data);
}

export const deleteEvaluationResults = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","evaluation-results/"+data.id);
   commit('status', res.data);
}

export const listEventCodes = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","event-codes", data)
   commit('listEventCodes', res.data);
   commit('definationLoading', false);
}

export const addEventCodes = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","event-codes", data);
   commit('status', res.data);
}

export const editEventCodes = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","event-codes/"+data.id, data);
   commit('status', res.data);
}

export const deleteEventCodes = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","event-codes/"+data.id);
   commit('status', res.data);
}

export const system_module_list = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","systemmodules")
   commit('listSystemModules', res.data);
   commit('definationLoading', false);
}

export const listMenus = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","system/menutitles", data)
   commit('listMenuTitles', res.data);
   commit('definationLoading', false);
}

export const addMenus = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("post","system/menus/"+data.menu_id+"/title", data)
   commit('status', res.data);
   commit('definationLoading', false);
}

export const editMenus = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("put","system/menus/"+data.menu_id+"/title/"+data.title_id, data)
   commit('status', res.data);
   commit('definationLoading', false);
}

export const listCustomFields = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","system/customfields", data)
   commit('listCustomFields', res.data);
   commit('definationLoading', false);
}

export const listForms = async ({ commit }, data) => {
   let res;
   res = await sendReq("get","/system/formlist", data)
   commit('listForms', res.data);
}

export const addCustomFields = async ({ commit }, data) => {
   let res;
   res = await sendReq("post","system/customfields", data)
   commit('status', res.data);
}

export const editCustomFields = async ({ commit }, data) => {
   let res;
   res = await sendReq("put","system/customfields/"+data.id, data)
   commit('status', res.data);
}

export const deleteCustomFields = async ({ commit }, data) => {
   let res;
   res = await sendReq("delete","system/customfields/"+data.id, data)
   commit('status', res.data);
}
export const listFormsCustomFields = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","system/customfields/"+data, data)
   commit('listFormsCustomFields', res.data);
   commit('definationLoading', false);
}
export const ticketStatus = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","statuses", data)
   commit('listTicketStatus', res.data);
   commit('definationLoading', false);
}
export const listReceivers = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","receivers", data)
   commit('listReceivers', res.data);
   commit('definationLoading', false);
}

export const receiverDetails = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","receivers/"+data.id)
   commit('receiverDetail', res.data);
   commit('definationLoading', false);
}

export const listRecProtocols = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","receiver-protocols", data)
   commit('listRecProtocols', res.data);
   commit('definationLoading', false);
}

export const addReceiver = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("post","receivers", data)
   commit('status', res.data);
   commit('definationLoading', false);
}

export const editReceiver = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("put","receivers/"+data.id, data)
   commit('status', res.data);
   commit('definationLoading', false);
}

export const deleteRec = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("delete","receivers/"+data.id, data)
   commit('status', res.data);
   commit('definationLoading', false);
}

export const listFormats = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","receiver-protocols/"+data+'/receiver-formats')
   commit('listProtocolFormats', res.data);
   commit('definationLoading', false);
}

export const addFormat = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("post","receiver-protocols/"+data.id+'/receiver-formats', data)
   commit('status', res.data);
   commit('definationLoading', false);
}

export const editFormat = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("put","receiver-formats/"+data.id, data)
   commit('status', res.data);
   commit('definationLoading', false);
}

export const deleteRecFormat = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("delete","/receiver-formats/"+data.id)
   commit('status', res.data);
   commit('definationLoading', false);
}

export const addRecProtocol = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("post","receiver-protocols", data)
   commit('status', res.data);
   commit('definationLoading', false);
}

export const editRecProtocol = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("put","receiver-protocols/"+data.id, data)
   commit('status', res.data);
   commit('definationLoading', false);
}
export const deleteRecProtocol = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("delete","/receiver-protocols/"+data.id)
   commit('status', res.data);
   commit('definationLoading', false);
}
export const copyRecProtocol = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("post","/receiver-formats/copy", data)
   commit('status', res.data);
   commit('definationLoading', false);
}
export const devicetype_list = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","/device_types", data)
   commit('getDeviceType', res.data);
   commit('definationLoading', false);
}
export const constants_get = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("get","/system/alr-constants", data)
   commit('constants', res.data);
   commit('definationLoading', false);
}
export const constants_put = async ({ commit }, data) => {
   commit('definationLoading', true);
   let res;
   res = await sendReq("put","/system/alr-constants", data)
   commit('status', res.data);
   commit('definationLoading', false);
}



// WEBPACK FOOTER //
// ./src/store/modules/Defination/Actions.js